document.addEventListener('DOMContentLoaded', () => {
  const STORAGE_KEY = 'jso-cookie-consent';
  const GA_MEASUREMENT_ID = 'G-1VR3NBD688';

  const banner = document.querySelector('#jso-consent-banner');
  if (!banner) return;

  const detailsPanel = document.querySelector('#jso-consent-details');
  const detailsToggle = document.querySelector('#jso-consent-details-toggle');
  const statsInput = document.querySelector('[data-jso-consent="statistics"]');
  const marketingInput = document.querySelector('[data-jso-consent="marketing"]');
  const acceptAllBtn = document.querySelector('#jso-consent-accept-all');
  const acceptSelectedBtn = document.querySelector('#jso-consent-accept-selected');
  const rejectBtn = document.querySelector('#jso-consent-reject');

  // Dowolny element na stronie (np. link w stopce) z atrybutem
  // data-cookie-settings pozwala użytkownikowi ponownie otworzyć baner
  // i zmienić wcześniej podjętą decyzję.
  const settingsTriggers = document.querySelectorAll('[data-jso-consent-settings]');

  const hideClasses = ['opacity-0', 'translate-y-6'];

  function readConsent() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      // np. tryb prywatny / brak dostępu do localStorage
      return null;
    }
  }

  function writeConsent(consent) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
    } catch (e) {
      // decyzja nie zostanie zapamiętana, ale nie blokujemy działania strony
    }
  }

  function loadGoogleAnalytics() {
    // Odblokuj wysyłkę danych, gdyby wcześniej została wyłączona
    window[`ga-disable-${GA_MEASUREMENT_ID}`] = false;

    if (document.getElementById('ga-script')) {
      console.log('✅ Google Analytics loaded');
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() {
      window.dataLayer.push(arguments);
    };

    const script = document.createElement('script');
    script.id = 'ga-script';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID);

    console.log('✅ Google Analytics loaded');
  }

  function blockGoogleAnalytics() {
    // Oficjalna flaga gtag.js wyłączająca wysyłkę danych – działa też,
    // gdy skrypt nie został jeszcze wcześniej załadowany.
    window[`ga-disable-${GA_MEASUREMENT_ID}`] = true;
    console.log('❌ Google Analytics blocked (no consent)');
  }

  function applyConsent(consent) {
    if (consent.statistics) {
      loadGoogleAnalytics();
    } else {
      blockGoogleAnalytics();
    }
  }

  function syncInputs(consent) {
    statsInput.checked = !!(consent && consent.statistics);
    marketingInput.checked = !!(consent && consent.marketing);
  }

  function show(consent) {
    syncInputs(consent);
    banner.classList.remove('hidden');

    // Wymuszenie reflow, aby przejście CSS zadziałało od razu po odkryciu banera
    void banner.offsetWidth;
    banner.classList.remove(...hideClasses);
  }

  function hide() {
    banner.classList.add(...hideClasses);
    window.setTimeout(() => banner.classList.add('hidden'), 300);
  }

  function saveConsent({ statistics, marketing }) {
    const consent = {
      necessary: true,
      statistics: !!statistics,
      marketing: !!marketing,
      updatedAt: new Date().toISOString(),
    };

    writeConsent(consent);
    applyConsent(consent);
    console.log('🔄 Cookie preferences updated', consent);
    hide();
  }

  detailsToggle.addEventListener('click', () => {
    const willOpen = detailsPanel.classList.contains('hidden');
    detailsPanel.classList.toggle('hidden');
    detailsToggle.setAttribute('aria-expanded', String(willOpen));
    detailsToggle.textContent = willOpen ? 'Ukryj szczegóły' : 'Szczegóły';
  });

  acceptAllBtn.addEventListener('click', () => {
    saveConsent({ statistics: true, marketing: true });
  });

  acceptSelectedBtn.addEventListener('click', () => {
    saveConsent({ statistics: statsInput.checked, marketing: marketingInput.checked });
  });

  rejectBtn.addEventListener('click', () => {
    saveConsent({ statistics: false, marketing: false });
  });

  settingsTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      show(readConsent());
    });
  });

  const existingConsent = readConsent();

  if (existingConsent) {
    applyConsent(existingConsent);
  } else {
    show(null);
  }
});
